// 首页模块路由配置 require 异步按需加载
export default [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: (resolve) => require(['@/views/home/Home'], resolve),
    meta: {
      index: '1',
      title: '活动首页'
    }
  },
  {
    path: '/activityRule',
    name: 'ActivityRule',
    component: (resolve) => require(['@/views/home/ActivityRule'], resolve),
    meta: {
      index: '2',
      title: '活动规则'
    }
  },
  {
    path: '/productList',
    name: 'ProductList',
    component: (resolve) => require(['@/views/home/ProductList'], resolve),
    meta: {
      index: '3',
      title: '景区产品'
    }
  },
  {
    path: '/productDetail',
    name: 'ProductDetail',
    component: (resolve) => require(['@/views/home/ProductDetail'], resolve),
    meta: {
      index: '4',
      title: '商户详情'
    }
  },
  {
    path: '/contactService',
    name: 'ContactService',
    component: (resolve) => require(['@/views/home/ContactService'], resolve),
    meta: {
      index: '5',
      title: '在线客服'
    }
  },
  { // 静态页面，不做项目用 工银Visa持卡人专享活动
    path: '/exclusiveActive',
    name: 'ExclusiveActive',
    component: (resolve) => require(['@/views/home/ExclusiveActive'], resolve),
    meta: {
      index: '5',
      title: '工银Visa持卡人专享活动'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/home/home.js